<template>
  <div style="width: 96%; margin: 0 auto" v-loading="loading">
    <div class="searchBox">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="今天" name="today"></el-tab-pane>
        <el-tab-pane label="昨天" name="yesterday"></el-tab-pane>
        <el-tab-pane label="本周" name="week"></el-tab-pane>
        <el-tab-pane label="本月" name="mouth"></el-tab-pane>
        <el-tab-pane label="上月" name="lastmouth"></el-tab-pane>
      </el-tabs>
      <el-date-picker
        v-model="dateValue"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        style="margin-left: 10px"
        @change="selectDate"
        value-format="timestamp"
        align="left"
      ></el-date-picker>
      <el-button
        type="primary"
        class="totalTimes"
        @click="showTotalTimesDialog = true"
        >在线总时长</el-button
      >
    </div>
    <div class="tableData">
      <el-table
        :data="tableData"
        border
        :max-height="tableHeight"
        highlight-current-row
        :header-cell-style="headerStyle"
        :cell-style="cellStyle"
      >
        <el-table-column
          property="statisTime"
          label="日期"
          width="130"
        ></el-table-column>
        <el-table-column property="realName">
          <template slot="header">
            <template>
              <span @click="chooseCustomer($event)">
                <span style="padding-right: 3px">客服昵称</span>
                <i class="el-icon-caret-bottom" />
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          property="onlineLength"
          label="在线时长"
        ></el-table-column>
        <el-table-column
          property="busyLength"
          label="忙碌时长"
        ></el-table-column>
        <el-table-column
          property="offlineLength"
          label="离开时长"
        ></el-table-column>
      </el-table>
      <div
        v-if="selectShow == true"
        class="customerDiv"
        :style="{ marginLeft: x, marginTop: y }"
      >
        <div
          class="itemCustomer"
          style="font-weight: 600; color: #000000"
          @click="selectCustomer('')"
        >
          全选
        </div>
        <div
          class="itemCustomer"
          v-for="(item, index) in customList"
          @click="selectCustomer(item)"
          v-bind:key="index"
        >
          {{ item.realName }}
        </div>
      </div>
    </div>

    <!-- 客服在线总时长 -->
    <el-dialog
      title="提示"
      width="80%"
      lock-scroll
      :close-on-click-modal="false"
      :visible.sync="showTotalTimesDialog"
    >
      <template slot="title">
        <span class="el-dialog__title">客服在线总时长</span>
      </template>
      <el-table
        :data="totalTimesTableData"
        border
        highlight-current-row
        :header-cell-style="headerStyle"
        :cell-style="cellStyle"
      >
        <el-table-column property="realName">
          <template slot="header">
            <template>
              <span>
                <span style="padding-right: 3px">客服昵称</span>
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          property="onlineLength"
          label="在线时长"
        ></el-table-column>
        <el-table-column
          property="busyLength"
          label="忙碌时长"
        ></el-table-column>
        <el-table-column
          property="offlineLength"
          label="离开时长"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "reportStatistics",
  components: {},
  data() {
    return {
      activeName: "today",
      startTime: "",
      endTime: "",
      csName: "",
      dateValue: [
        new Date(new Date().toLocaleDateString()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ],
      tableData: [],
      customerData: [],
      selectShow: false,
      x: "",
      y: "",
      tableHeight: 400,
      showTotalTimesDialog: false,
      totalTimesTableData: [],
      loading: false,
    };
  },
  mounted() {
    var start = new Date(new Date().toLocaleDateString()).getTime();
    this.startTime = this.util.timeStampToDate(start, 0);
    var end = Date.parse(new Date());
    this.endTime = this.util.timeStampToDate(end, 0);
    console.log("*****startTime,endTime*****", this.startTime, this.endTime);
    this.getDurationByTime();
    this.getCurrentDepartBelowUsers();
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      this.tableHeight = window.innerHeight - seaH - 120;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        this.tableHeight = window.innerHeight - seaH - 120;
      });
    });
  },
  watch: {},
  methods: {
    async getDurationByTime() {
      var api = "/manager/csStatus/selectDurationByTimeAndSummary";
      this.loading = true;
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          startTime: this.startTime,
          endTime: this.endTime,
          csName: this.csName,
        },
      });
      console.log(
        "reportStatistics getDurationByTime response ===> ",
        response
      );

      if (response.resultCode === "10000") {
        this.tableData = response.data.list;
        this.totalTimesTableData = response.data.summary;
        this.loading = false;
      } else {
        this.$message.error(response.desc);
      }
    },
    async getCurrentDepartBelowUsers() {
      var api = "/manager/user/getCurrentDepartBelowUsers";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log(
        "reportStatistics getCurrentDepartBelowUsers response ===> ",
        response
      );

      if (response.resultCode === "10000") {
        this.customList = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    headerStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return "text-align:center;color:#000000;";
      } else {
        return "text-align:left;";
      }
    },

    cellStyle() {
      return "text-align:center;";
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    handleClick(tab) {
      var name = tab.name;
      var start;
      var end;
      var now = new Date();
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0; //
      if (nowDayOfWeek === 0) {
        nowDayOfWeek = 7;
      }
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastMonth = lastMonthDate.getMonth();
      if (name === "today") {
        start = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.endTime = this.util.timeStampToDate(end, 0);
      } else if (name === "yesterday") {
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000;
        this.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.endTime = this.util.timeStampToDate(end, 0);
      } else if (name === "week") {
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        this.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(
          new Date(nowYear, nowMonth, nowDay + 8 - nowDayOfWeek).getTime() - 1
        );
        this.endTime = this.formatDate(end) + " 23:59:59";
        // this.endTime = this.formatDate(end) + " 23:59:59";
      } else if (name === "mouth") {
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24); //本月天数
        start = new Date(nowYear, nowMonth, 1);
        // this.startTime = this.formatDate(start) + " 00:00:00";

        this.startTime = this.formatDate(start) + " 00:00:00";

        end = new Date(nowYear, nowMonth, days + 1);
        end = new Date(new Date(end).getTime() - 1);
        this.endTime = this.formatDate(end) + " 23:59:59";
        // this.endTime = this.formatDate(end) + " 23:59:59"; //返回当月结束时间
      } else if (name === "lastmouth") {
        var lastMonthStartDate1 = new Date(nowYear, lastMonth, 1);
        var lastMonthEndDate1 = new Date(nowYear, lastMonth + 1, 1);
        var days1 =
          (lastMonthEndDate1 - lastMonthStartDate1) / (1000 * 60 * 60 * 24);
        start = new Date(nowYear, lastMonth, 1);
        this.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, lastMonth, days1);
        this.endTime = this.formatDate(end) + " 23:59:59";
      }
      console.log(this.dateValue);
      console.log(this.startTime, this.endTime);
      this.handleGetTime(this.startTime, this.endTime);
      console.log(
        "reportStatistics handleClick date",
        name,
        this.startTime,
        this.endTime
      );
      this.getDurationByTime();
    },
    // 给时间选择器赋值
    handleGetTime(start, end) {
      if (this.dateValue === null) {
        this.dateValue = [];
      }
      this.dateValue.splice(
        0,
        2,
        new Date(start).getTime(),
        new Date(end).getTime()
      );
      console.log(this.dateValue);
    },
    selectDate() {
      this.activeName = "";
      if (this.dateValue === null) {
        var start = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.util.timeStampToDate(start, 0);
        var end = Date.parse(new Date());
        this.endTime = this.util.timeStampToDate(end, 0);
      } else {
        this.startTime = this.util.timeStampToDate(this.dateValue[0], 0);
        this.endTime = this.util.timeStampToDate(this.dateValue[1], 0);
      }
      console.log(
        "reportStatistics selectDate startTime endTime === ",
        this.startTime,
        this.endTime
      );
      this.getDurationByTime();
    },
    chooseCustomer($event) {
      this.selectShow = !this.selectShow;
      this.x = String($event.pageX - 80) + "px";
      this.y = String($event.pageY + 20) + "px";
      console.log("reportStatistics chooseCustomer", this.x, this.y);
    },
    selectCustomer(item) {
      console.log("reportStatistics selectCustomer", item);
      if (item === "") {
        this.csName = "";
      } else {
        this.csName = item.realName;
      }
      this.selectShow = false;
      this.getDurationByTime();
    },
  },
};
</script>

<style>
.customerDiv {
  min-width: 120px;
  height: 260px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  z-index: 999;
}
.itemCustomer {
  height: 25px;
  line-height: 25px;
  padding: 5px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 10px;
  overflow: hidden;
}
.itemCustomer:hover {
  background-color: #ebeef5;
}
</style>
<style scoped lang="scss">
.searchBox :deep() {
  .totalTimes {
    height: 40px;
    margin-left: 10px;
    border-radius: 2px;
    background-color:#1577d2;
  }
  .el-tabs__item {
    min-width: 64px;
    height: 40px;
    line-height: 40px;
    padding: 0 10px !important;
    text-align: center;
    @include change_size($font_size_normal);
  }

  .el-tabs__header {
    border-bottom: 1px solid #ffffff !important;
    margin: 0;
  }

  .el-tabs__item.is-active {
    border-bottom-color: #1577d2 !important;
    background-color: #1577d2;
    color: #fff;
  }

  .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }

  .el-tabs,
  .el-tabs--card,
  .el-tabs--top {
    float: left;
  }

  .el-form-item {
    min-width: 0 !important;
  }

  .buttons {
    width: 200px;
  }
}

// 客服统计报表样式
.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}

.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}
::v-deep .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
